import { createIcon } from '@chakra-ui/react';

export const StatsWarningIcon = createIcon({
  displayName: 'StatsWarningIcon',
  viewBox: '0 0 48 48',
  defaultProps: {
    fill: 'none',
    height: '48',
    width: '48',
  },
  path: (
    <>
      <circle cx="24" cy="24.2754" r="24" fill="#FFEFE6" />
      <path
        d="M23.2285 14.5898C23.6545 14.1638 24.3455 14.1638 24.7715 14.5898L33.6855 23.5039C34.1116 23.9299 34.1116 24.6208 33.6855 25.0469L24.7715 33.9609C24.3455 34.387 23.6545 34.387 23.2285 33.9609L14.3145 25.0469C13.8884 24.6208 13.8884 23.9299 14.3145 23.5039L23.2285 14.5898Z"
        fill="#E67635"
        stroke="#E67635"
        strokeWidth="2.18182"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M24 19.2754V24.7754" stroke="white" strokeWidth="2" strokeLinecap="round" />
      <circle cx="24" cy="28.2754" r="0.5" fill="white" stroke="white" />
    </>
  ),
});
